import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Injector,
  Input,
  ViewChild
} from '@angular/core'
import {
  ControlContainer,
  ControlValueAccessor,
  FormControl,
  FormControlDirective,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {MultiSelectEnumComponent} from '../form-inputs/multi-select-enum/multi-select-enum.component';
import {TranslatePipe} from '@ngx-translate/core';
import {Backend} from '@generated-backend-types';
import ModelStateEnum = Backend.App.Enums.ModelStateEnum;

@Component({
    selector: 'app-state-card',
    templateUrl: './state-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => StateCardComponent),
            multi: true
        }
    ],
  imports: [MultiSelectEnumComponent, MultiSelectEnumComponent, TranslatePipe],
  standalone: true
})
export class StateCardComponent implements ControlValueAccessor {
  public ModelStateEnum = ModelStateEnum;

  public constructor(
    private readonly injector: Injector,
  ) {}

  @ViewChild(FormControlDirective, {static: true})
  public formControlDirective?: FormControlDirective;

  @Input()
  public formControl?: FormControl;

  @Input()
  public formControlName!: string;

  @Input()
  public omit: ModelStateEnum[] = [];

  @Input()
  public errorMessages: Record<string, string> = {};

  public get control(): FormControl {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <FormControl>this.formControl ?? this.controlContainer.control.get(this.formControlName);
  }

  get value(): ModelStateEnum {
    return this.formControl?.getRawValue();
  }

  get controlContainer(): ControlContainer {
    return this.injector.get(ControlContainer);
  }

  registerOnTouched(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: () => void): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: () => void): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(): void {
    // da formControl und control identisch sind brauchen wir hier nichts weiter zu geben

  }
}
